"use client";

import dynamic from "next/dynamic";

// Re-export all components with dynamic loading
export const Dialog = dynamic(() => import("./Dialog").then(mod => ({ default: mod.Dialog })));
export const DialogTrigger = dynamic(() => import("./Dialog").then(mod => ({ default: mod.DialogTrigger })));
export const DialogPortal = dynamic(() => import("./Dialog").then(mod => ({ default: mod.DialogPortal })));
export const DialogClose = dynamic(() => import("./Dialog").then(mod => ({ default: mod.DialogClose })));
export const DialogOverlay = dynamic(() => import("./Dialog").then(mod => ({ default: mod.DialogOverlay })));
export const DialogContent = dynamic(() => import("./Dialog").then(mod => ({ default: mod.DialogContent })));
export const DialogHeader = dynamic(() => import("./Dialog").then(mod => ({ default: mod.DialogHeader })));
export const DialogFooter = dynamic(() => import("./Dialog").then(mod => ({ default: mod.DialogFooter })));
export const DialogTitle = dynamic(() => import("./Dialog").then(mod => ({ default: mod.DialogTitle })));
export const DialogDescription = dynamic(() => import("./Dialog").then(mod => ({ default: mod.DialogDescription })));
